import { render, staticRenderFns } from "./last-padron-info.vue?vue&type=template&id=f7328e92&scoped=true&"
import script from "./last-padron-info.component.ts?vue&type=script&lang=ts&"
export * from "./last-padron-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./last-padron-info.vue?vue&type=style&index=0&id=f7328e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7328e92",
  null
  
)

export default component.exports